import React, { useState, useRef } from 'react';
import { FiCopy, FiCheck } from 'react-icons/fi';

const CopyValue = ({ value, label }) => {
  const [copied, setCopied] = useState(false);
  const timer = useRef(null);

  const copy = async () => {
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(value);
      } else {
        const ta = document.createElement('textarea');
        ta.value = value;
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
      }
      setCopied(true);
      if (timer.current) clearTimeout(timer.current);
      timer.current = setTimeout(() => setCopied(false), 1600);
    } catch {
      /* ignore */
    }
  };

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
      <span className="cy-mono">{value}</span>
      <button
        type="button"
        className="cy-copy"
        onClick={copy}
        aria-label={`${label ? 'Copy ' + label : 'Copy'}`}
      >
        {copied ? <FiCheck aria-hidden="true" /> : <FiCopy aria-hidden="true" />}
        <span role="status">{copied ? 'Copied' : 'Copy'}</span>
      </button>
    </span>
  );
};

const DlFacts = ({ rows }) => (
  <dl className="cy-facts">
    {rows.map((row, i) => (
      <div className="cy-facts__row" key={i}>
        <dt>{row.label}</dt>
        <dd>
          {row.href ? (
            <a className="cy-link" href={row.href}>
              {row.value}
            </a>
          ) : row.copyable ? (
            <CopyValue value={row.value} label={row.label} />
          ) : (
            row.value
          )}
        </dd>
      </div>
    ))}
  </dl>
);

export { CopyValue };
export default DlFacts;
